// Parse a user-supplied CSV or XLSX/XLS file into row objects keyed by header.
// SheetJS reads all three formats, so one code path covers "csv or xlsx".
import * as XLSX from 'xlsx';

export type ParsedImport = { headers: string[]; rows: Record<string, any>[] };

export async function parseImportFile(file: File): Promise<ParsedImport> {
  const buf = await file.arrayBuffer();
  const wb = XLSX.read(buf, { type: 'array' });
  const first = wb.SheetNames[0];
  if (!first) return { headers: [], rows: [] };
  const ws = wb.Sheets[first];
  const rows = XLSX.utils.sheet_to_json<Record<string, any>>(ws, { defval: '', raw: false });
  // drop fully-empty rows
  const clean = rows.filter((r) => Object.values(r).some((v) => String(v ?? '').trim() !== ''));
  const headers = clean.length ? Object.keys(clean[0]) : [];
  return { headers, rows: clean };
}

export function downloadCsvTemplate(filename: string, headers: string[], sample?: Record<string, string>) {
  const esc = (v: string) => (/[",\n]/.test(v) ? '"' + v.replace(/"/g, '""') + '"' : v);
  const head = headers.map(esc).join(',');
  const body = sample ? headers.map((h) => esc(sample[h] ?? '')).join(',') : '';
  const csv = body ? head + '\n' + body : head;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 1000);
}
